module.exports = __webpack_public_path__ + "done-f1f1aec926ca4123a76700aedd2ca55d.svg";